import Constants from "components/utils/constants";
const mux = (f) => Constants.agGridFieldDefFactor(f);


let fieldType = (factor = 1, typeMap) => {
    return {
        headerName: '',
        field: 'type',
        width: 32 * mux(factor),
        cellStyle: { margin: "0px", padding: "2px" },
        cellRenderer: (params) => {
            let code = params.value;
            let name = typeMap[code];
            let icon = `<img 
            width="24px" 
            style="background: transparent;"
            src="assets/img/accounts/icons/${code}.png"
            alt="${name}" />`;
            return `<a  key={account._id} href="/transactions/${params.data._id}">${icon}</a>`;
        }
    }
}
let fieldName = (factor = 1, props={width: 72}) => {
    return {
        headerName: 'Chitfund Name',
        field: 'name',
        width: props.width * mux(factor),
        cellStyle: { margin: "0px", padding: "2px" },
        cellRenderer: (params) => {
            return (
                `<a  key={account._id} href="/redirect/account/${params.data._id}">${params.value}</a>`
            )
        }
    }
}
let fieldCode = (factor = 1) => {
    return {
        headerName: 'Account Code',
        field: 'code',
        width: 140 * mux(factor),
        cellRenderer: (params) => {
            return `<a  key={account._id} href="/transactions/${params.data._id}">${params.value}</a>`;
        }
    }
}
let fieldDesc = (factor = 1) => {
    return {
        headerName: 'Description',
        field: 'desc',
        width: 220 * mux(factor)
    }
}
let fieldCurr = (factor = 1) => {
    return {
        headerName: 'Currency',
        field: 'curr',
        cellStyle: { margin: "0px", padding: "2px" },
        width: 40 * mux(factor)
    }
}
let fieldSince = (factor = 1) => {
    return {
        headerName: 'Inception',
        field: 'date',
        width: 100 * mux(factor),
        cellRenderer: (params) => {
            return params.value?.substr(0, 10);
        }
    }
}
let fieldTerm = (factor = 1, props={width: 40}) => {
    return {
        headerName: 'Term',
        field: 'term',
        width: props.width * mux(factor),
        cellRenderer: (params) => {
            let nextTerm = params.data.chit_info?.nextTerm;
            if (nextTerm && nextTerm > -1) {
                return `Term ${params.data.chit_info?.nextTerm}`;
            } else if (nextTerm === -1) {
                return 'Closed'
            } else {
                return 'New'
            }

        }
    }
}
let fieldUpdated = (factor = 1) => {
    return {
        headerName: 'Updated',
        field: 'updated_at',
        width: 120 * mux(factor),
        cellRenderer: (params) => {
            return Constants.timeAgo(params.value)
        }
    }
}
let fieldBalance = (factor = 1) => {
    return {
        headerName: 'Balance',
        field: 'bal',
        cellStyle: { textAlign: "right" },
        width: 60 * mux(factor),
        cellRenderer: (params) => {
            return Constants.toCurrency(Number(params.value), params.data.curr);
        }
    }
}
let fieldActions = (factor = 1, props={width: 94}) => {
    return {
        headerName: 'Actions',
        width: props.width * mux(factor),
        cellRenderer: (params) => {
            return (
                `<a  key={account._id} href="/transactions/${params.data._id}">Dashboard</a>`
            )
        }
    }
}


export const AccountGrid = (typeMap, width) => {

    let definitions = {
        portable: [
            fieldType(1, typeMap),
            fieldName(1, {width: 180}),
            fieldTerm(1, {width: 72}),
            fieldActions(1, {width: 90}),
            // fieldSince(),
        ],
        mobile: [
            fieldType(1, typeMap),
            fieldName(1, {width: 242}),
            fieldTerm(1, {width: 64}),
            fieldActions(1, {width: 90}),
            // fieldSince(),
        ],
        tablet: [
            fieldType(1, typeMap),
            fieldName(4),
            fieldActions(1),
            fieldCode(2),
            fieldTerm(3),
            fieldCurr(2),
            fieldBalance(2),
            fieldSince(),
        ],
        laptop: [
            fieldType(2, typeMap),
            fieldName(4),
            fieldActions(2),
            fieldCode(2),
            fieldDesc(1),
            fieldTerm(3),
            fieldCurr(2),
            fieldBalance(3),
            fieldSince(2),
            // fieldUpdated(2),
        ],
        wide: [
            fieldType(2, typeMap),
            fieldName(4),
            fieldActions(2),
            fieldCode(3),
            fieldDesc(3),
            fieldTerm(3),
            fieldCurr(2),
            fieldBalance(3),
            // fieldURL(),
            fieldSince(2),
            fieldUpdated(2),
        ],
    }

    if  (width > 1440) {
        // monitor
        return definitions.wide
    }  else if (width > 1024) {
        // laptop
        return definitions.laptop
    }  else if (width > 440) {
        // tablet
        return definitions.tablet
    } else if (width > 400) {
        // mobile
        return definitions.mobile
    } else {
        // portable
        return definitions.portable
    }
}